import { createContext, useContext } from 'react';
import theme from '../themes';

const UiComponentTheme = createContext(theme);
const useTheme = (): typeof theme => useContext(UiComponentTheme);

export { useTheme };
